import {
  Directive,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';


export class RpFormGroupDirective implements OnChanges {
  /**
   * Access host's FormGroup
   */
   formGroup = new FormGroup({});

  /**
   * Manually show errors
   */
   showErrors = false;

  /**
   * Emits formGroup value if formGroup is valid
   */
   rpSubmit = new EventEmitter();

  /**
   * Emits true when an invalid form is submitted
   */
   submitFail = new EventEmitter();

  /**
   * Boolean steam of error display toggling
   * TODO Doesn't look like this is ever false after it's been triggered once
   */
  showErrors$ = new BehaviorSubject(false);

  /**
   * Handle form submissions, marking as failed and preventing submit if formGroup is invalid
   */
   catchSubmit() {
    if (this.formGroup.invalid) {
      // TODO Scroll to top
      this.submitFail.emit(true);
      this.showErrors$.next(true);
    } else {
      this.rpSubmit.emit(this.formGroup.value);
    }
  }

  /**
   * Check formGroup validity and show errors if needed
   */
  ngOnChanges({showErrors}: SimpleChanges) {
    if (showErrors && showErrors.currentValue === true) {
      this.catchSubmit(); // Initialize outputs with form status
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[formGroup]'}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'formGroup': [{ type: Input },],
'showErrors': [{ type: Input },],
'rpSubmit': [{ type: Output },],
'submitFail': [{ type: Output },],
'catchSubmit': [{ type: HostListener, args: ['submit', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
